exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* The grey checkbox colour for locked participants lives in the global SCSS\n   (.employees-list .employee .name input.locked-checkbox) because the checkbox\n   uses appearance:none custom styling that ignores accent-color. */\n.name.is-locked > div[data-v-7c75f29c] {\n    color: #9aa0a6;\n    font-style: italic;\n}\n", ""]);

// exports
